export default __webpack_public_path__ + "static/media/ko.js.cc189150.map";